export const GENDER_OPTIONS = [
  { label: 'Male', value: 'male' },
  { label: 'Female', value: 'female' },
]

export const YES_NO_OPTIONS = [
  { label: 'Yes', value: 'true' },
  { label: 'No', value: 'false' },
]

// Order + values MUST match IntakeResponse::DENTAL_CONDITIONS_OPTIONS.
// Labels from IntakeResponsesHelper#dental_conditions.
export const DENTAL_CONDITIONS = [
  { value: 'tooth_pain', label: 'Tooth pain/sensitivity' },
  { value: 'jaw_pain', label: 'Jaw joint pain' },
  { value: 'jaw_clicking', label: 'Popping/clicking in jaw joint(s)' },
  { value: 'jaw_stiffness', label: 'Jaw muscle stiffness' },
  { value: 'neck_stiffness', label: 'Head/Neck muscles stiffness' },
  { value: 'neck_pain', label: 'Neck pain' },
  { value: 'tension_headaches', label: 'Tension headaches' },
  { value: 'face_injures', label: 'Injures to face, mouth or teeth' },
  { value: 'temperature_sensitivity', label: 'Sensitivity to temperature' },
  { value: 'pressure_sensitivity', label: 'Sensitivity to pressure' },
  { value: 'gum_bleeding', label: 'Gums bleed when brushing' },
  { value: 'morning_discomfort', label: 'Teeth or jaw discomfort in the morning' },
  { value: 'clenching', label: 'Clenching during the day' },
  { value: 'teeth_grinding', label: 'Teeth grinding' },
  { value: 'chronic_ringing', label: 'Chronic ringing in ears' },
]

// Order + values MUST match IntakeResponse::MEDICAL_ISSUES_OPTIONS.
// Labels from IntakeResponsesHelper#medical_issues.
export const MEDICAL_ISSUES = [
  { value: 'anemia', label: 'Anemia' },
  { value: 'arthritis', label: 'Arthritis, rheumatism' },
  { value: 'artificial_heart_valves', label: 'Artificial heart valves' },
  { value: 'artificial_joints', label: 'Artificial joints, pins, etc.' },
  { value: 'asthma', label: 'Asthma' },
  { value: 'bleeding_abnormally', label: 'Bleeding abnormally' },
  { value: 'blood_disease', label: 'Blood disease' },
  { value: 'cancer', label: 'Cancer' },
  { value: 'chemical_dependency', label: 'Chemical dependency' },
  { value: 'chemotherapy', label: 'Chemotherapy' },
  { value: 'circulatory_problems', label: 'Circulatory problems' },
  { value: 'congenital_heart_lesions', label: 'Congenital heart lesions' },
  { value: 'diabetes', label: 'Diabetes' },
  { value: 'epilepsy', label: 'Epilepsy' },
  { value: 'fainting', label: 'Fainting' },
  { value: 'glaucoma', label: 'Glaucoma' },
  { value: 'headaches', label: 'Headaches' },
  { value: 'heart_murmur', label: 'Heart murmur' },
  { value: 'heart_problems', label: 'Heart problems' },
  { value: 'hemophilia', label: 'Hemophilia' },
  { value: 'hepatitis', label: 'Hepatitis' },
  { value: 'high_blood_pressure', label: 'High blood pressure' },
  { value: 'hiv_aids', label: 'HIV AIDS' },
  { value: 'jaw_pain', label: 'Jaw pain' },
  { value: 'kidney_disease', label: 'Kidney disease' },
  { value: 'liver_disease', label: 'Liver disease' },
  { value: 'mitral_valve_prolapse', label: 'Mitral valve prolapse' },
  { value: 'pacemaker', label: 'Pacemaker' },
  { value: 'radiation_treatment', label: 'Radiation treatment' },
  { value: 'respiratory_disease', label: 'Respiratory disease' },
  { value: 'rheumatic_fever', label: 'Rheumatic fever' },
  { value: 'scarlet_fever', label: 'Scarlet fever' },
  { value: 'sexually_transmitted_disease', label: 'Sexually transmitted disease' },
  { value: 'stroke', label: 'Stroke' },
  { value: 'swelling', label: 'Swelling of feet or ankles' },
  { value: 'thyroid_problems', label: 'Thyroid problems' },
  { value: 'tonsillitis', label: 'Tonsillitis' },
  { value: 'tuberculosis', label: 'Tuberculosis' },
  { value: 'ulcer', label: 'Ulcer' },
]

// Radio booleans. premedication/latex_allergic/smoked required; pregnant optional.
export const BOOLEAN_FIELDS = [
  'premedication',
  'latex_allergic',
  'smoked',
  'pregnant',
]

// Presence-validated fields (IntakeResponse validations). address_2 excluded.
export const REQUIRED_FIELDS = [
  'legal_name',
  'birthdate',
  'gender',
  'address_1',
  'city',
  'state',
  'zip_code',
  'email',
  'phone_number',
  'referred_by',
  'emergency_name',
  'emergency_relationship',
  'emergency_phone_number',
]

// Field → section index, mirrors IntakeResponsesHelper section_*_fields.
export const SECTION_FIELDS = {
  personal: [
    'legal_name',
    'birthdate',
    'gender',
    'address_1',
    'city',
    'state',
    'zip_code',
    'email',
    'phone_number',
    'referred_by',
  ],
  emergency: ['emergency_name', 'emergency_relationship', 'emergency_phone_number'],
  dentalHistory: ['premedication'],
  medicalHistory: ['latex_allergic', 'smoked'],
}
